import React from 'react';
import { FadeIn } from './FadeIn';
import { ArrowRightIcon, DownloadIcon } from 'lucide-react';
export function CTASection() {
  return <section id="contact" className="py-24 relative overflow-hidden" data-id="element-59">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-navy to-slate z-0" data-id="element-60"></div>
      <div className="absolute inset-0 bg-grid-pattern opacity-20 z-0" data-id="element-61"></div>

      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-62">
        <FadeIn data-id="element-63">
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6" data-id="element-64">
            Ready to Future-Proof Your Institution?
          </h2>
          <p className="text-xl text-gray-400 mb-10 max-w-2xl mx-auto" data-id="element-65">
            Schedule a confidential briefing with our team to explore how FIQIS
            can strengthen your security, unlock new revenue, and modernize your
            infrastructure.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-66">
            <a href="mailto:arthur@fiqis.com?subject=Demo%20Request%20-%20FiQIS" className="w-full sm:w-auto bg-teal hover:bg-teal-400 text-navy font-bold px-8 py-4 rounded-md transition-all duration-300 hover:shadow-[0_0_20px_rgba(0,212,170,0.4)] flex items-center justify-center gap-2 text-lg" data-id="element-67">
              Request a Demo
              <ArrowRightIcon className="w-5 h-5" data-id="element-68" />
            </a>
          </div>
        </FadeIn>
      </div>
    </section>;
}